import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'assignment-gap-choice-row',
    templateUrl: './assignment-gap-choice-row.component.html',
    styleUrls: ['./assignment-gap-choice-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AssignmentGapChoiceRowComponent {}
